import { render, staticRenderFns } from "./AddProducts.vue?vue&type=template&id=4b06addc&scoped=true"
import script from "./AddProducts.vue?vue&type=script&lang=js"
export * from "./AddProducts.vue?vue&type=script&lang=js"
import style0 from "./AddProducts.vue?vue&type=style&index=0&id=4b06addc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06addc",
  null
  
)

export default component.exports